import "./WaitingComp.css";
import { defineComponent as s, computed as r, openBlock as i, createElementBlock as c, createElementVNode as t, normalizeClass as p, pushScopeId as a, popScopeId as _ } from "vue";
import { _ as l } from "./_plugin-vue_export-helper.dad06003.js";
const d = (e) => (a("data-v-38f186b9"), e = e(), _(), e), h = ["width", "height"], m = /* @__PURE__ */ d(() => /* @__PURE__ */ t("circle", {
  cx: "12",
  cy: "12",
  r: "10",
  fill: "none",
  "stroke-width": "2"
}, null, -1)), u = [
  m
], g = /* @__PURE__ */ s({
  __name: "WaitingComp",
  props: {
    size: {
      type: String,
      default: "65"
    },
    white: Boolean,
    secondaryGray: Boolean,
    brandBlue: Boolean
  },
  setup(e) {
    const o = e, n = r(() => ({
      spinner__group: !0,
      "spinner--white": o.white,
      "spinner--secondaryGray": o.secondaryGray,
      "spinner--brandBlue": o.brandBlue
    }));
    return (w, f) => (i(), c("svg", {
      class: "spinner-comp",
      width: o.size,
      height: o.size,
      stroke: "#000",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      t("g", {
        class: p(n.value)
      }, u, 2)
    ], 8, h));
  }
});
const b = /* @__PURE__ */ l(g, [["__scopeId", "data-v-38f186b9"]]);
export {
  b as WaitingComp
};
//# sourceMappingURL=WaitingComp.js.map
